import { UserProfile } from '@/services/userService';
import { AccountType } from '@/contexts/UserContext';

export const userProfileToTalentCompat = (profile: UserProfile) => {
  return {
    id: profile.id,
    name: profile.display_name,
    sport: 'General', // Default sport
    talentType: profile.talent?.talent_type || 'athlete',
    photo: '🏃',
    avatarUrl: profile.avatar_url || '/api/placeholder/150/150',
    totalFollowers: 0,
    totalRevenue: 0,
    totalHoldings: 0,
    avgBusinessImpact: 0,
    joinDate: profile.created_at.split('T')[0],
    status: 'Active' as const,
    tier: 'Silver' as const,
    achievements: [],
    stats: {},
    socialProfiles: [],
    agentContact: null,
    bio: profile.bio || '',
    location: profile.location || '',
    isVerified: profile.is_verified || false
  };
};

export const getDisplayName = (profile: UserProfile | null, accountType: AccountType | null): string => {
  if (!profile) return 'User';
  
  switch (accountType) {
    case 'talent':
      return profile.talent?.name || profile.display_name || 'Talent';
    case 'brand':
      return profile.brand?.company_name || profile.display_name || 'Brand';
    case 'agent':
      return profile.agent?.professional_name || profile.display_name || 'Agent';
    case 'venture':
      return profile.venture_capital?.firm_name || profile.display_name || 'Venture';
    default:
      return profile.display_name || 'User';
  }
};